import { useCallback } from 'preact/hooks'
import { useLocation } from 'wouter-preact'

export function useBack(fallback = '/') {
  const [, setLocation] = useLocation()

  return useCallback(() => {
    const from = window.history.state?.from

    if (from) {
      window.history.back()
    }
    else {
      setLocation(fallback, { replace: true })
    }
  }, [fallback, setLocation])
}
